
import { SubscriptionPlans } from '../components/subscription';

export function SubscribePage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-900 to-purple-900/20">
      <SubscriptionPlans />
    </div>
  );
}
